(function () {
	'use strict';
	$(document).ready(function () {

		// handle tables in accordions
		$('.subpage .accordion .collapse').on('shown.bs.collapse', function () {
			updateTableSize();
			$(window).resize();
		});

		// accordion scroll animation
		$('.subpage .accordion.scroll-animation .collapse').on('shown.bs.collapse', function () {
			const positionTop = $(this).parent().offset().top; // - $('header').height();
			$('html, body').animate({
				scrollTop: positionTop,
			}, 500);
		});

		const slidersColumnWithImage = document.querySelectorAll('.swiper.slider-column-with-image');
		if (slidersColumnWithImage.length > 0) {
			for (const sliderColumnWithImage of slidersColumnWithImage) {
				const prevElement = sliderColumnWithImage.parentNode.parentNode.querySelector('.swiper-navigation-prev')
				const nextElement = sliderColumnWithImage.parentNode.parentNode.querySelector('.swiper-navigation-next')
				new Swiper(sliderColumnWithImage, {
					slidesPerView: 1,
					autoHeight: true,
					navigation: {
						prevEl: prevElement,
						nextEl: nextElement,
					},
				});
			}
		}

		const slidersColumnWithBigNumbers = document.querySelectorAll('.swiper.slider-column-with-big-numbers');
		if (slidersColumnWithBigNumbers.length > 0) {
			for (const sliderColumnWithBigNumbers of slidersColumnWithBigNumbers) {
				const prevElement = sliderColumnWithBigNumbers.parentNode.parentNode.querySelector('.swiper-navigation-prev')
				const nextElement = sliderColumnWithBigNumbers.parentNode.parentNode.querySelector('.swiper-navigation-next')
				new Swiper(sliderColumnWithBigNumbers, {
					slidesPerView: 1,
					navigation: {
						prevEl: prevElement,
						nextEl: nextElement,
					},
				});
			}
		}

		const slidersImageWithBigNumbers = document.querySelectorAll('.swiper.slider-image-with-big-numbers');
		if (slidersImageWithBigNumbers.length > 0) {
			for (const sliderImageWithBigNumbers of slidersImageWithBigNumbers) {
				const prevElement = sliderImageWithBigNumbers.parentNode.parentNode.querySelector('.swiper-navigation-prev')
				const nextElement = sliderImageWithBigNumbers.parentNode.parentNode.querySelector('.swiper-navigation-next')
				new Swiper(sliderImageWithBigNumbers, {
					slidesPerView: 1,
					autoHeight: true,
					navigation: {
						prevEl: prevElement,
						nextEl: nextElement,
					},
				});
			}
		}

		const galerries = document.querySelectorAll('.swiper.gallery');
		if (galerries.length > 0) {
			for (const gallery of galerries) {
				const prevElement = gallery.parentNode.parentNode.querySelector('.swiper-navigation-prev')
				const nextElement = gallery.parentNode.parentNode.querySelector('.swiper-navigation-next')
				const withThumbs = gallery.dataset.thumbnails;
				const props = withThumbs ? {
					pagination: {
						el: '.gallery-pagination-bullets',
						clickable: true,
						renderBullet: function (index, className) {
							return '<li class="' + className + '">' + document.querySelector(`.gallery-image-${index}`).cloneNode(true).outerHTML + '</li>';
						}
					},
				} : {
					slidesPerView: 1.5,
					centeredSlides: true,
					spaceBetween: 24,
				};
				new Swiper(gallery, {
					loop: true,
					navigation: {
						prevEl: prevElement,
						nextEl: nextElement,
					},
					...props,
				});
			}
		}

		// responsive-image module zoomable feature
		document.querySelectorAll('.module.responsive-image .image-container.zoomable .desktop-image').forEach((containerElement) => {
			const popupContainer = document.createElement('div');
			popupContainer.classList.add('popup-image-container');
			const clonedImg = containerElement.parentElement.querySelector('.popup-image img').cloneNode(true);
			clonedImg.classList.add('popup-image');
			popupContainer.appendChild(clonedImg);

			const removePopupContainer = () => {
				$(popupContainer).fadeOut(() => {
					popupContainer.remove();
				});
			};
			popupContainer.addEventListener('click', removePopupContainer);

			const mediaQuery = window.matchMedia('(min-width: 768px)');
			mediaQuery.addEventListener('change', () => {
				if (!mediaQuery.matches) {
					removePopupContainer();
				}
			});
			containerElement.querySelector('img').addEventListener('click', () => {
				if (mediaQuery.matches) {
					document.body.appendChild(popupContainer);
					$(popupContainer).fadeIn();
				}
			});
		});

		//Tooltipster

		// default tooltips
		$('.default-tooltipster').tooltipster({
			maxWidth: 290,
			contentAsHTML: true,
			interactive: true,
			functionPosition: function (instance, helper, position) {
				position.coord.left = helper.geo.origin.offset.left - 20;
				return position;
			},
		});

	});
}(jQuery));
